"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkQuality = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const network_signal_level_1 = require("./network_signal_level");
const network_quality_text_1 = require("./network_quality_text");
const network_quality_dropdown_menu_1 = require("./network_quality_dropdown_menu");
const network_quality_lost_connection_text_1 = require("./network_quality_lost_connection_text");
const rxjs_1 = require("../../../../hooks/rxjs");
const room_session_1 = require("../../../../context/room_session");
const NetworkQuality = () => {
    const roomSession = (0, room_session_1.useRoomSession)();
    const [callStartTime] = (0, rxjs_1.useObservable)(roomSession.bookmarks.callStartTime);
    const [showNetworkQuality, setShowNetworkQuality] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!callStartTime)
            return;
        const networkQualityTimeoutId = setTimeout(() => {
            setShowNetworkQuality(true);
        }, 1000);
        return () => clearTimeout(networkQualityTimeoutId);
    }, [callStartTime]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(NetworkQualityContainer, { children: [(0, jsx_runtime_1.jsx)(network_signal_level_1.NetworkSignalLevel, { showNetworkQuality: showNetworkQuality }), (0, jsx_runtime_1.jsx)(network_quality_text_1.NetworkQualitySignalText, {}), (0, jsx_runtime_1.jsx)(network_quality_dropdown_menu_1.NetworkQualityDropdown, { showNetworkQuality: showNetworkQuality })] }), (0, jsx_runtime_1.jsx)(network_quality_lost_connection_text_1.NetworkSignalLevelLostConnectionText, { showNetworkQuality: showNetworkQuality })] }));
};
exports.NetworkQuality = NetworkQuality;
const NetworkQualityContainer = (0, ui_react_1.styled)(ui_react_1.Flex)(() => ({
    alignItems: 'center',
    marginLeft: '3px',
}));
//# sourceMappingURL=network_quality.js.map